export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state('activities', {
      parent: "app",
      url: "/administration/activities",
      feature: "", //"menu.administration.activities",
      views: {
        "main": {
          template: require("./eaActivitiesPage/eaActivitiesPageModule.html"),
          controller: "ActivitiesPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {

              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaAdministration/eaActivities/routes.js